/* eslint-disable import/prefer-default-export */

export enum PciFeatureFlag {
  BlogEnabled = 'BLOG_ENABLED',
  MediaCenterEnabled = 'MEDIA_CENTER_ENABLED',
  GoogleReviewsEnabled = 'GOOGLE_REVIEWS_ENABLED',
}
